import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput.css'

const inputs = document.querySelectorAll('.tel-input')

inputs.forEach(input => {
	const iti = intlTelInput(input, {
		formatOnDisplay: true,
		separateDialCode: true
	})
})
